import { Tab } from "@blueprintjs/core";
import * as React from "react";
import { useHistory, useParams } from "react-router";
import { PageBase, ProtectedTabs, BackButton } from "../../../components";
import { ERoutes } from "../../../ERoutes";
import { useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { DogFusionPage } from "./DogFusionPage";

export interface IDogFusionItemPageProps {}

export const DogFusionItemPage: React.FunctionComponent<IDogFusionItemPageProps> = (props) => {
  const { id, tab } = useParams<{ id: string; tab: string }>();
  const { t } = useTl();
  const history = useHistory();

  return (
    <PageBase
      breadCrumbs={[
        {
          text: t(ETLCodes.DogFusion),
          route: ERoutes.dog,
        },
      ]}
    >
      <ProtectedTabs
        id="FusePersonTabs"
        onChange={(newTabId) => history.push(`${ERoutes.dog}/${id}/${newTabId}/edit`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.dog}/>
        <Tab id="fusion" title={t(ETLCodes.Fusion)} panel={<DogFusionPage/>} />
      </ProtectedTabs>
    </PageBase>
  );
};
